<i18n src="../translations"></i18n>

<template>
  <Table
    :is-ajax="true"
    :url="ajaxUrl"
    :load-more="true"
    :load-more-label="$t('product-info-sections.more-car-types')"
    :initial-rows-limit="initialRowsLimit"
    table-key="carTypes"
    :has-border="false"
    :transform="sortCarTypes"
    :row-class="rowClass"
    @tableIsEmpty="$emit('empty', 'carTypes')"
  >
    <template v-slot:model="{ entity, index }">
      <div v-if="isMatch(entity) && index === 0" class="match-info">
        <Icon class="icon" name="check" width="16" height="16" />
        <span class="label">{{
          $t('product-info-sections.car-match-label')
        }}</span>
      </div>
      {{ entity.model }}
    </template>
  </Table>
</template>

<script>
import Table from 'Components/01-atoms/table/Table';
import globalMixin from 'Libs/mixins/globalMixin';
import Icon from 'Components/00-generated/Icon';
import { mapState } from 'vuex';

export default {
  name: 'PdpCarTypesTable',
  components: { Table, Icon },
  mixins: [globalMixin],
  props: {
    productId: { type: String, required: true },
    initialRowsLimit: { type: Number, default: 4 },
  },
  computed: {
    ...mapState('core', {
      ktypnr: ({ placeholders }) => {
        const hasVehicle =
          placeholders?.carSelection?.data?.vehicle !== undefined;
        const vehicle = hasVehicle && placeholders.carSelection.data.vehicle;
        return vehicle ? vehicle.ktypnr : null;
      },
    }),
    ajaxUrl() {
      if (!this.productId) return '';
      return this.interpolateUrl(
        this.frontFacingPath('search.ajax.product.car.data'),
        { productId: this.productId }
      );
    },
  },
  methods: {
    interpolateUrl(path, params) {
      const interpolate = this.$options.filters?.interpolate;
      if (typeof interpolate === 'function') return interpolate(path, params);
      return path?.replace('{productId}', this.productId);
    },
    isMatch(entity) {
      return entity && entity.carId === this.ktypnr;
    },
    sortCarTypes(entities) {
      if (!Array.isArray(entities) || !this.ktypnr) return entities;

      return [...entities].sort(
        (a, b) => (b.carId === this.ktypnr) - (a.carId === this.ktypnr)
      );
    },
    rowClass(entity) {
      return this.isMatch(entity) ? 'match-row' : '';
    },
  },
};
</script>

<style scoped lang="scss">
.match-info {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-weight: bold;

  .icon {
    color: var(--color-kfzteile24-semantic-green);
  }
}

::v-deep .match-row {
  background: var(--color-success-green);
}
</style>
